import React from 'react'
import { Form, Spinner } from 'react-bootstrap'
import PositionList from '../Form/PositionList.jsx'
import { useLocalReturnDataState } from '../../../stores/LocalReturnDataProvider'
import MetaInfoBlock from '../Form/MetaInfoBlock.jsx'
import HeaderData from '../Form/HeaderData.jsx'

const StoreReturnContentArea = () => {
  const {
    formErrors,
    headerData,
    resetErrorByFormKey, setHeaderDataByKey,
    positions,
    loadedReturnData,
    addPosition,
    copyPosition,
    splitPosition,
    setPositions,
    actionMode
  } = useLocalReturnDataState()
  return (
    <Form>
      {
        !loadedReturnData
          ?
          <div className="d-flex align-items-center justify-content-center">< Spinner animation='border' variant='primary' /></div >
          :
          <>
            <div className='container-fluid'>
            <MetaInfoBlock headerData={headerData}/>
            <div className="mb-5" />
            <HeaderData actionMode={actionMode} headerData={headerData} setHeaderDataByKey={setHeaderDataByKey} formErrors={formErrors} resetErrorByFormKey={resetErrorByFormKey} />
            <PositionList actionMode={actionMode} addPosition={addPosition} copyPosition={copyPosition} splitPosition={splitPosition} positions={positions} setPositions={setPositions} formErrors={formErrors} resetErrorByFormKey={resetErrorByFormKey} />
            </div>
          </>
      }
    </Form>
  )

}

export default StoreReturnContentArea

